enum GatheringPhotosFilter {
  Active = 'Active',
  ActiveCaptureSort = 'ActiveCaptureSort',
  AllCaller = 'AllCaller',
  Hidden = 'Hidden'
}
export default GatheringPhotosFilter
